import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

class AdminHaut extends React.Component {
    render() {
        return <div className="adminHaut">
            <h2 className="adminHaut__ttl">{this.props.ttl}</h2>
            <div className="adminHaut__opts">
                {
                    this.props.options.map((opt, key) => {
                        if (opt.type == "link") {
                            return <Link
                                key={`opt-${key}`}
                                title={opt.ttl}
                                aria-label={opt.ttl}
                                to={opt.link}
                                className={`adminHaut__btn ${opt.col != null && `adminHaut__btn--${opt.col}`}`}
                            >
                                <FontAwesomeIcon icon={opt.ico} />
                            </Link>
                        } else {
                            return <button
                                key={`opt-${key}`}
                                title={opt.ttl}
                                aria-label={opt.ttl}
                                onClick={() => {opt.action()}}
                                className={`adminHaut__btn adminHaut__btn--${opt.col}`}
                            >
                                <FontAwesomeIcon icon={opt.ico} />
                            </button>
                        }
                    })
                }
            </div>
        </div>
    }
}

export default AdminHaut;